import axios, { AxiosError, AxiosResponse } from "axios";
import { AuthBodyType } from "../types";
import {
  ChecklistReportType,
  CamposOcultosImpressao,
  ConfiguracoesImpressao,
  filters,
  filtersV2,
  OtimizacaoHtml,
} from "../types/reports/types";
import { applyFirebaseTokenRetry } from './api';

export type { ChecklistReportType, ChecklistSubitemReport } from "../types/reports/types";
export type TicketDetailsResponse = {
  execucoes: ChecklistReportType[];
};

export class Reportsv2 {
  private api = applyFirebaseTokenRetry(axios.create({
    baseURL: `${process.env.REACT_APP_AXYMA_MICROSSERVICES_APIS_URL}/relatorios`,
  }));

  getExecutionsV2 = async (body: AuthBodyType, filters: filtersV2 | null | undefined, lastIndex: number | null, itensPerPage: number) => {
    try {
      const data: AxiosResponse = await this.api.post("", {
        ...body,
        filters,
        lastIndex,
        itensPerPage,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getDetailsForTicket = async (body: AuthBodyType, inicio: number, formAnonimoId?: string | null): Promise<TicketDetailsResponse> => {
    const response = await this.api.post<TicketDetailsResponse>("/getDetailsForTicket", {
      ...body,
      empresa: body.userEmpresa,
      inicio,
      ...(formAnonimoId !== undefined ? { formAnonimoId } : {}),
    });
    return response.data;
  };

  getFiltersByEntity = async (body: AuthBodyType, entity: string): Promise<TicketDetailsResponse> => {
    const response = await this.api.post<TicketDetailsResponse>("/getFiltersByEntity", {
      ...body,
      entity,
    });
    return response.data;
  };
  getSharePdf = async (
    body: AuthBodyType,
    dataInicio: number[],
    camposOcultos?: CamposOcultosImpressao,
    configuracoesImpressao?: ConfiguracoesImpressao,
    otimizacaoHtml?: OtimizacaoHtml,
  ) => {
    try {
      const data: AxiosResponse = await this.api.post("/share", {
        ...body,
        dataInicio,
        camposOcultos,
        configuracoesImpressao,
        otimizacaoHtml,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };
}

export default class Reports {
  private api = applyFirebaseTokenRetry(axios.create({
    baseURL: `${process.env.REACT_APP_API_HOST}/relatorios`,
  }));


  deleteExecucao = async (body: AuthBodyType, timestamp: number, usuario: string) => {
    try {
      const data: AxiosResponse = await this.api.post("/deleteExecucao", {
        ...body,
        timestamp,
        usuario,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getData = async (body: AuthBodyType, entity: string, cursor?: string | null, limit?: number) => {
    try {
      const data: AxiosResponse = await this.api.post("/getStatistic", {
        ...body,
        entity,
        ...(cursor !== undefined ? { cursor } : {}),
        ...(limit !== undefined ? { limit } : {}),
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getFilters = async (body: AuthBodyType, filters: filters, pageNumber: number, itensPerPage: number) => {
    try {
      const data: AxiosResponse = await this.api.post("/getExecutions", {
        ...body,
        filters,
        pageNumber,
        itensPerPage,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getImages = async (imagesList: string[]) => {
    try {
      const data: AxiosResponse = await this.api.post("/getImages", {
        imagesList,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getLink = async (body: AuthBodyType, user: string | null, modeloChecklist: string | null, inicio: number, projectName: string) => {
    try {
      const data: AxiosResponse = await this.api.post("/getLink", {
        ...body,
        user,
        modeloChecklist,
        inicio,
        projectName,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getExecutionById = async (id: string, userTimeStamp?: { user: string | undefined; timestamp: number | undefined }) => {
    try {
      const data: AxiosResponse = await this.api.post("/getExecutionById", {
        id,
        userTimeStamp,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getScoringValues = async (body: AuthBodyType, form: { inicio: number; user: string }) => {
    try {
      const data: AxiosResponse = await this.api.post("/getScoringValues", {
        ...body,
        form,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getExecutionsV2 = async (body: AuthBodyType, filters: filtersV2 | null | undefined, lastIndex: number | null, itensPerPage: number) => {
    try {
      const data: AxiosResponse = await this.api.post("/getExecutionsV2", {
        ...body,
        filters,
        lastIndex,
        itensPerPage,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  getDetailsById = async (body: AuthBodyType, ids: { user: string; timestamp: number }[]) => {
    try {
      const data: AxiosResponse = await this.api.post("/getDetailsById", {
        ...body,
        ids,
      });
      return data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (axios.isAxiosError(error)) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };
}

// export default Reports;
